export default __webpack_public_path__ + "static/media/turntablist.05ce9540.mp3";